import { logger } from 'services/logger';

export function safeDecodeUriComponent(component: string) {
    try {
        return decodeURIComponent(component);
    } catch (error) {
        logger.debug(error);
        return component;
    }
}
